module.exports = __webpack_public_path__ + "img/butterfields-150.c7fe630a.jpg";